module.exports = __webpack_public_path__ + "media/images/flags/ke-fa3a0d10ea0f50aca82ed7a6c1551518.svg";